import React from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button,
} from 'reactstrap';
import PropTypes from 'prop-types';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';

function ModalConfirm({
  open, toggle, title, callback, saving,
}) {
  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirmation</ModalHeader>
      <ModalBody>
        {title}
      </ModalBody>

      <ModalFooter>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={saving}
          onClick={() => callback()}
          data-style={EXPAND_RIGHT}
        >
          {saving ? 'Saving' : 'Confirm'}
        </LaddaButton>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
}

ModalConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  callback: PropTypes.func,
  title: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
};

ModalConfirm.defaultProps = {
  callback: undefined,
};

export default ModalConfirm;
